import { gql } from '@apollo/client'
import { CHATBOT_QUICK_PROMPT_FIELDS } from './fragments/chatbot_quick_prompt'

export const DELETE_CHATBOT_QUICK_PROMPT = gql`
  ${CHATBOT_QUICK_PROMPT_FIELDS}
  mutation deleteChatbotQuickPrompt($id: ID!) {
    deleteChatbotQuickPrompt(id: $id) {
      ...ChatbotQuickPromptFields
    }
  }
`
